<template>
  <main class="detail-page">
    <button type="button" class="back-button" @click="$router.back()">
      <a-icon type="arrow-left" /> 返回展厅
    </button>

    <div v-if="loading" class="state">正在打开作品...</div>
    <div v-else-if="!work" class="state">作品不存在或已停止展示</div>
    <article v-else class="detail-layout">
      <section class="gallery">
        <div class="primary-image">
          <img :src="currentImage" :alt="work.title" @error="handleImageError">
        </div>
        <div v-if="images.length > 1" class="thumbnails">
          <button
            v-for="(image, index) in images"
            :key="image"
            type="button"
            :class="{ active: activeImage === index }"
            @click="activeImage = index"
          >
            <img :src="image" :alt="`${work.title}-${index + 1}`" @error="handleImageError">
          </button>
        </div>
      </section>

      <aside class="work-copy">
        <p class="category">{{ work.categoryName }}</p>
        <h1>{{ work.title }}</h1>
        <div class="meta-line">
          <span>作者：{{ work.authorName }}</span>
          <span><a-icon type="eye" /> {{ work.viewCount || 0 }}</span>
        </div>
        <div v-if="work.material" class="material">
          <span>作品材料</span>
          <strong>{{ work.material }}</strong>
        </div>
        <div class="description">
          <span>作品说明</span>
          <p>{{ work.description }}</p>
        </div>
      </aside>
    </article>
  </main>
</template>

<script>
import { getShowcaseWorkDetail } from "@/api/Showcase";
import { replaceBrokenImage } from "@/utils/workImage";

const FALLBACK_IMAGE = require("@/assets/images/nopic.png");

export default {
  name: "ShowcaseWorkDetail",
  data() {
    return { loading: false, work: null, activeImage: 0 };
  },
  computed: {
    images() {
      if (!this.work) return [];
      const list = Array.isArray(this.work.imageList) ? this.work.imageList : [];
      return list.length ? list : [this.work.coverUrl || FALLBACK_IMAGE];
    },
    currentImage() {
      return this.images[this.activeImage] || FALLBACK_IMAGE;
    },
  },
  mounted() {
    this.loadDetail();
  },
  methods: {
    loadDetail() {
      this.loading = true;
      getShowcaseWorkDetail(this.$route.params.id)
        .then((res) => { this.work = res.data || null; })
        .catch((error) => { this.$message.error((error && error.msg) || "作品详情加载失败"); })
        .finally(() => { this.loading = false; });
    },
    handleImageError(event) {
      replaceBrokenImage(event, FALLBACK_IMAGE);
    },
  },
};
</script>

<style lang="scss" scoped>
.detail-page { min-height: calc(100vh - 180px); padding: 38px max(5vw, 28px) 80px; background: #f3efe7; color: #26231f; }
.back-button { margin-bottom: 28px; border: 0; background: transparent; color: #5c665f; cursor: pointer; }
.detail-layout { display: grid; grid-template-columns: minmax(0, 1.45fr) minmax(340px, .75fr); gap: clamp(36px, 6vw, 92px); width: min(1380px, 100%); margin: auto; }
.primary-image { min-height: 560px; background: #ddd7cb; }
.primary-image img { display: block; width: 100%; height: min(72vh, 760px); object-fit: contain; }
.thumbnails { display: flex; gap: 12px; overflow-x: auto; padding-top: 14px; }
.thumbnails button { width: 92px; height: 70px; flex: 0 0 auto; padding: 3px; border: 1px solid transparent; background: #fff; cursor: pointer; }
.thumbnails button.active { border-color: #b8833c; }
.thumbnails img { width: 100%; height: 100%; object-fit: cover; }
.work-copy { align-self: center; }
.category { color: #b17b35; font-size: 13px; letter-spacing: .16em; }
.work-copy h1 { margin: 12px 0 20px; font-family: Georgia, "Noto Serif SC", serif; font-size: clamp(38px, 4vw, 62px); font-weight: 500; line-height: 1.18; }
.meta-line { display: flex; justify-content: space-between; padding-bottom: 24px; border-bottom: 1px solid #d5ccbe; color: #777064; }
.material, .description { padding-top: 28px; }
.material span, .description span { display: block; margin-bottom: 10px; color: #aa7a38; font-size: 13px; letter-spacing: .12em; }
.material strong { font-size: 17px; font-weight: 500; }
.description p { color: #5f5a52; font-size: 16px; line-height: 2; white-space: pre-wrap; }
.state { padding: 140px 0; text-align: center; color: #837a6e; }
@media (max-width: 860px) { .detail-layout { grid-template-columns: 1fr; } .primary-image { min-height: 320px; } .primary-image img { height: 55vh; } }
</style>
